import React from 'react'
import { hydrateRoot, type Root } from 'react-dom/client'
import { createUserContext } from './create-user-context'
import { createTenantMapping } from './create-tenant-mapping'
import type { FragmentRootOptions } from '@vp/ubik-fragment-types'
import { createRootOptions } from '../common'
import type { ClientMountOptions } from './deprecated'
import { createRootProvider } from './create-root-provider'

export async function clientMount(Component: React.ReactElement, rootElement: HTMLElement, options: FragmentRootOptions): Promise<Root>
/**
 * @deprecated since version 0.2.1, use updated clientMount (3 arguments)
 */
export async function clientMount(Component: React.ReactElement, options: ClientMountOptions): Promise<Root>
export async function clientMount(
  Component: React.ReactElement,
  optionsOrRootElement: HTMLElement | ClientMountOptions,
  renderOptionsOrUndefined: FragmentRootOptions | undefined = undefined,
): Promise<Root> {
  const rootElement = optionsOrRootElement instanceof HTMLElement === false ? optionsOrRootElement.rootElement : optionsOrRootElement

  const userContext = createUserContext()
  const tenantMappings = await createTenantMapping(userContext.tenant, userContext.locale)

  const rootOptions = createRootOptions(renderOptionsOrUndefined)
  const hydrateOptions = rootOptions.hydrateOptions ?? {}

  const { Provider } = await createRootProvider({
    userContext,
    rootOptions: renderOptionsOrUndefined,
    tenantMappings,
  })

  return hydrateRoot(rootElement, <Provider>{Component}</Provider>, {
    ...hydrateOptions,
    // Must match the server's identifierPrefix or every `useId` hydration mismatches.
    // server-render defaults it to the fragment rootElementId, which is this element's id.
    identifierPrefix: hydrateOptions.identifierPrefix ?? rootElement.id,
  })
}
